import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { injectIntl } from 'react-intl';
import { AboutUs } from './AboutUs';
export default withTheme(withRouter(injectIntl(AboutUs)));
